// extracted by mini-css-extract-plugin
export var boxItems = "_8c-1";
export var boxItemsLg = "_8c-2";
export var button = "_8c-7";
export var buttonHoverless = "_8c-9";
export var buttonLg = "_8c-8";
export var filterGroupBox = "_8c-0";
export var icon = "_8c-3";
export var iconSecondary = "_8c-6";
export var iconWrapper = "_8c-4";
export var iconWrapperLg = "_8c-5";
export var truncatedLabel = "_8c-a";